export default {
  'quotations.domain.enums.quotation_status.configuring': 'Configurando',
  'quotations.domain.enums.quotation_status.awaiting_offers':
    'Aguardando Ofertas',
  'quotations.domain.enums.quotation_status.answered': 'Respondido',
  'quotations.domain.enums.quotation_status.winners_selected':
    'Vencedores Selecionados',
  'quotations.domain.enums.quotation_status.done': 'Encerrado',

  'quotations.domain.enums.item_type.part': 'Peça',
  'quotations.domain.enums.item_type.consumable': 'Insumo',

  'quotations.domain.enums.quotation_supplier_status.not_offered':
    'Não ofertado',
  'quotations.domain.enums.quotation_supplier_status.offered': 'Ofertado',

  'quotations.list.button.newQuotation': 'Nova Cotação',
  'quotations.list.table.title.employeeName': 'Funcionário',
  'quotations.list.table.title.code': 'Código',
  'quotations.list.table.title.companyName': 'Empresa',
  'quotations.list.table.title.date': 'Data',
  'quotations.list.table.title.status': 'Status',

  'quotations.form.id': 'ID.',
  'quotations.form.company': 'Empresa',
  'quotations.form.employee': 'Funcionário',
  'quotations.form.date': 'Data',
  'quotations.form.status': 'Status',

  'quotations.create': 'Criar Cotação',
  'quotations.create.notification.success': 'Sucesso',
  'quotations.create.notification.successDescription':
    'Cotação criada com sucesso.',

  'quotations.update': 'Editar Cotação',
  'quotations.update.notification.success': 'Sucesso',
  'quotations.update.notification.successDescription':
    'Cotação atualizada com sucesso.',

  'quotations.remove': 'Remover Cotação',
  'quotations.remove.alert': 'Você realmente deseja remover a cotação:',
  'quotations.remove.notification.success': 'Sucesso',
  'quotations.remove.notification.successDescription': 'Cotação removida.',

  'quotations.details': 'Detalhes da Cotação',

  'quotations.details.report': 'Relatório da cotação',
  'quotations.details.report.selectReportType': 'Selecione o tipo de relatório',
  'quotations.details.report.itemsSuppliers': 'Itens/Fornecedores',
  'quotations.details.report.suppliersItems': 'Fornecedores/Itens',
  'quotations.details.report.quotationItems': 'Itens da cotação',
  'quotations.details.report.supplierWinners': 'Fornecedores Vencedores',

  'quotations.details.report.success.message': 'Sucesso',
  'quotations.details.report.success.messageDescription':
    'Relatório gerado com sucesso.',

  'quotations.details.report.error.message': 'Erro',
  'quotations.details.report.error.messageDescription':
    'Relatório não está disponível no momento.',

  'quotations.details.items': 'Itens a serem Cotados',
  'quotations.details.items.originalCode': 'Cód. Interno',
  'quotations.details.items.manufacturingCode': 'Cód. Fabricante',
  'quotations.details.items.name': 'Nome',
  'quotations.details.items.manufacturer': 'Fabricante',
  'quotations.details.items.type': 'Tipo',
  'quotations.details.items.quantity': 'Qtd.',

  'quotations.details.items.nextError.message': 'Erro',
  'quotations.details.items.nextError.description':
    'Deve haver ao menos um item',

  'quotations.details.items.create': 'Adicionar Item',

  'quotations.details.items.create.filter': 'Pesquise',
  'quotations.details.items.create.filter.description':
    'Pesquise por itens para adicionar',
  'quotations.details.items.create.filter.toBeAdded':
    'Itens a serem adicionados',
  'quotations.details.items.create.filter.search': 'Busca',
  'quotations.details.items.create.filter.type': 'Tipo',

  'quotations.details.items.create.setUp': 'Configure',
  'quotations.details.items.create.setUp.description':
    'Configure a quantidade de itens',

  'quotations.details.items.create.notification.success': 'Sucesso',
  'quotations.details.items.create.notification.successDescription':
    'Itens da cotação adicionados.',

  'quotations.details.items.update': 'Editar item da cotação',
  'quotations.details.items.update.notification.success': 'Sucesso',
  'quotations.details.items.update.notification.successDescription':
    'Item da cotação alterado.',

  'quotations.details.items.remove': 'Remover item da cotação',
  'quotations.details.items.remove.alert':
    'Você realmente deseja remover o item:',
  'quotations.details.items.remove.notification.success': 'Sucesso',
  'quotations.details.items.remove.notification.successDescription':
    'Item da cotação removido.',

  'quotations.details.suppliers': 'Fornecedores',
  'quotations.details.suppliers.name': 'Nome',
  'quotations.details.suppliers.email': 'E-Mail',
  'quotations.details.suppliers.type': 'Tipo',
  'quotations.details.suppliers.status': 'Status',

  'quotations.details.suppliers.create': 'Adicionar Fornecedor',

  'quotations.details.suppliers.remove': 'Remover fornecedor da cotação',
  'quotations.details.suppliers.remove.alert':
    'Você realmente deseja remover o fornercedor:',
  'quotations.details.suppliers.remove.notification.success': 'Sucesso',
  'quotations.details.suppliers.remove.notification.successDescription':
    'Fornecedor da cotação removido.',

  'quotations.details.suppliers.nextError.message': 'Erro',
  'quotations.details.suppliers.nextError.description':
    'Deve haver ao menos um fornecedor',

  'quotations.details.offersConfiguration': 'Configuração das Ofertas',
  'quotations.details.offersConfiguration.save': 'Salvar Configuração',
  'quotations.details.offersConfiguration.save.notification.success': 'Sucesso',
  'quotations.details.offersConfiguration.save.notification.successDescription':
    'Configuração das ofertas da cotação atualizada.',

  'quotations.details.offersConfiguration.nextError.message': 'Erro',
  'quotations.details.offersConfiguration.nextError.description':
    'Selecione um fornecedor e salve a configuração para prosseguir.',

  'quotations.details.sendQuotationRequest': 'Enviar Pedido de Cotação',
  'quotations.details.sendQuotationRequest.send': 'Enviar',
  'quotations.details.sendQuotationRequest.subject': 'Assunto',
  'quotations.details.sendQuotationRequest.content': 'Mensagem',
  'quotations.details.sendQuotationRequest.attachment': 'Anexo',
  'quotations.details.sendQuotationRequest.attachmentText':
    'Clique ou arraste um arquivo nesta área para fazer o upload',
  'quotations.details.sendQuotationRequest.attachmentHint':
    'Adicione os arquivos a serem enviados como anexo no pedido de cotação.',
  'quotations.details.sendQuotationRequest.notification.success': 'Sucesso',
  'quotations.details.sendQuotationRequest.notification.successDescription':
    'Requisição de cotação enviada.',

  'quotations.details.generatePurchase': 'Gerar Compra',
};
